
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut"])
      });
    }
  